// extracted by mini-css-extract-plugin
export var noSpinners = "_on-6";
export var percentageInput = "_on-7";
export var variantColor1 = "_on-0";
export var variantColor2 = "_on-1";
export var variantColor3 = "_on-2";
export var variantColor4 = "_on-3";
export var variantColor5 = "_on-4";
export var variantColor6 = "_on-5";